import { ResponsivePie } from "@nivo/pie";
import { useEffect, useState } from "react";
import formatShort from "../../../utils/formatShort";
import revenueByDept from "../../../utils/revenueByDept";
import { REACT_APP_ARPS_BASE_URL } from "../../../utils/urls";
const RevenueDept = ({ startDate, endDate }: any) => {
  const [revenues, setRevenues] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(0);

  const fetchRevenues = async () => {
    setLoading(true);
    const response = await fetch(
      `${REACT_APP_ARPS_BASE_URL}/revenue/workshop/department?start=${startDate}&end=${endDate}`
    );
    const data = await response.json();
    const res = revenueByDept(data);

    setRevenues(res);
    setLoading(false);
  };

  useEffect(() => {
    fetchRevenues();
  }, [startDate]);

  return (
    <ResponsivePie
      data={revenues}
      margin={{ top: 40, right: 120, bottom: 120, left: 120 }}
      innerRadius={0.5}
      padAngle={0.7}
      cornerRadius={3}
      activeOuterRadiusOffset={8}
      borderWidth={1}
      borderColor={{
        from: "color",
        modifiers: [["darker", 0.2]],
      }}
      valueFormat={(value: any) => `${formatShort(value)}`}
      arcLinkLabelsSkipAngle={10}
      arcLinkLabelsTextColor="#333333"
      arcLinkLabelsThickness={2}
      arcLinkLabelsColor={{ from: "color" }}
      arcLabelsSkipAngle={10}
      arcLabelsTextColor={{
        from: "color",
        modifiers: [["darker", 2]],
      }}
      defs={[
        {
          id: "dots",
          type: "patternDots",
          background: "inherit",
          color: "rgba(255, 255, 255, 0.3)",
          size: 4,
          padding: 1,
          stagger: true,
        },
        {
          id: "lines",
          type: "patternLines",
          background: "inherit",
          color: "rgba(255, 255, 255, 0.3)",
          rotation: -45,
          lineWidth: 6,
          spacing: 10,
        },
      ]}
      fill={[
        {
          match: {
            id: "ruby",
          },
          id: "dots",
        },
        {
          match: {
            id: "c",
          },
          id: "dots",
        },
        {
          match: {
            id: "go",
          },
          id: "dots",
        },
        {
          match: {
            id: "python",
          },
          id: "dots",
        },
        {
          match: {
            id: "scala",
          },
          id: "lines",
        },
        {
          match: {
            id: "lisp",
          },
          id: "lines",
        },
        {
          match: {
            id: "elixir",
          },
          id: "lines",
        },
        {
          match: {
            id: "javascript",
          },
          id: "lines",
        },
      ]}
      legends={[
        {
          anchor: "right",
          direction: "column",
          justify: false,
          translateX: 140,
          translateY: 0,
          itemWidth: 120,
          itemHeight: 20,
          itemsSpacing: 0,
          symbolSize: 20,
          itemDirection: "left-to-right",
        },
      ]}
    />
  );
};

export default RevenueDept;
